import { IJsonQuery } from '../../../repositories/common/json_query';
import { BannerNew, EUserType, SuccessModal } from '@cian/demand-trap-widget';
import * as React from 'react';
import { ElementInViewport } from '../../../common/components/element_in_viewport';
import { ICreateMessageRequest } from '../../../repositories/demand/v2/create-message';
import { getApplicationFormQuery } from '../../../utils/demand/getApplicationFormQuery';
import { TBannerLocation, trackBannerShow, trackChangedUserType, trackSendFormClick } from './tracking';
import { IUserGADataLayerData } from '../../../common/state';

export interface IDemandFormData {
  name: string;
  phone: string;
  email: string;
  message?: string;
  userType?: string;
  companyName?: string;
  hasAgentProfile?: boolean;
}

export interface ITrapProps {
  isSuccessModalOpen: boolean;
  name?: string;
  email?: string;
  phone?: string;
  isAuthenticated?: boolean;
  dealType: string;
  realtyType: string;
  realtyCategory: string;
  region: string;
  jsonQuery: IJsonQuery;
  publicProfile: boolean;
  displayName?: string;
  isHomeOwner?: boolean;
  bannerLocation: TBannerLocation;
  containerRef?: React.MutableRefObject<HTMLDivElement>;
  userGADataLayerData?: IUserGADataLayerData | null;
  deviceType?: string;
  soprApi?: string;
  currentPageNumber?: number;
  currentResultPageNumber?: number;
  position?: number;
  queryString?: string;
  observerKey?: string | number;
  roomCount?: string;

  demandRequestCreateMessageStartAction(data: ICreateMessageRequest): void;

  demandCloseSuccessModalAction(): void;
}

export class Trap extends React.Component<ITrapProps, {}> {
  private isBannerVisibleTrackDone = false;

  private changeUserType = (userType: string) => {
    const { bannerLocation } = this.props;
    trackChangedUserType(userType, bannerLocation);
  };

  private handleSubmitClick = (userType: string) => {
    const { bannerLocation } = this.props;
    trackSendFormClick(userType, bannerLocation);
  };

  private handleFormSubmit = (formData: IDemandFormData) => {
    const { jsonQuery, publicProfile, displayName, demandRequestCreateMessageStartAction } = this.props;

    const parameters: ICreateMessageRequest = {
      email: formData.email,
      fullName: formData.name,
      jsonQuery,
      phone: formData.phone,
      isHomeowner: formData.userType === 'homeowner',
      source: 'Listing',
    };

    if (publicProfile) {
      parameters.companyName = formData.companyName || displayName;
      parameters.hasAgentProfile = formData.hasAgentProfile || publicProfile;
    }

    demandRequestCreateMessageStartAction(parameters);
  };

  private createMessage = (formData: IDemandFormData) => {
    const { userType, phone, email } = formData;
    const { realtyType, realtyCategory, dealType, bannerLocation, region, roomCount } = this.props;

    if (userType === 'homeowner') {
      window.location.assign(
        `/application-form/${getApplicationFormQuery(
          phone,
          email,
          realtyType,
          realtyCategory,
          dealType,
          bannerLocation,
          region,
          roomCount,
        )}`,
      );
    } else {
      this.handleFormSubmit(formData);
    }
  };

  private handleTrapShowInViewport = (visible: boolean) => {
    if (visible && !this.isBannerVisibleTrackDone) {
      const { bannerLocation } = this.props;
      trackBannerShow(bannerLocation);

      this.isBannerVisibleTrackDone = true;
    }
  };

  public render() {
    const {
      isSuccessModalOpen,
      demandCloseSuccessModalAction,
      email,
      phone,
      isAuthenticated,
      isHomeOwner,
      containerRef,
    } = this.props;

    return (
      <div ref={containerRef}>
        <ElementInViewport onChange={this.handleTrapShowInViewport}>
          <BannerNew
            email={email}
            phone={phone}
            isAuthenticated={isAuthenticated}
            userType={isHomeOwner ? EUserType.HomeOwner : EUserType.User}
            changeUserType={this.changeUserType}
            handleSubmitClick={this.handleSubmitClick}
            disclaimerText="Оставьте заявку, и с вами свяжется специалист"
            disclaimerHeader="Помощь надёжных риэлторов"
            createMessage={this.createMessage}
          />
        </ElementInViewport>
        {isSuccessModalOpen && <SuccessModal onCloseClick={demandCloseSuccessModalAction} />}
      </div>
    );
  }
}
